(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["flexora-main-accords"] && !Shopify.designMode) return;
  try {
    (() => {
  const initializeAccords = (root = document) => {
    const charts = root.querySelectorAll('.flexora-accords:not([data-reveal-ready])');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    charts.forEach((chart) => {
      chart.dataset.revealReady = 'true';
      chart.classList.add('flexora-accords--reveal');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          requestAnimationFrame(() => requestAnimationFrame(() => chart.classList.add('flexora-accords--visible')));
          observer.unobserve(chart);
          observer.disconnect();
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -35px 0px' });
      observer.observe(chart);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAccords(), { once: true });
  else initializeAccords();
  document.addEventListener('shopify:section:load', (event) => initializeAccords(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
